import { z } from 'zod'

export const internAgreementSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
})

export type InternAgreementSearch = z.infer<typeof internAgreementSearchSchema>
